import '.bi{flex-shrink:0;}.ssr-plugin'
import '.bk{padding:1rem;}.ssr-plugin'
import '.t{width:100%;}.ssr-plugin'
import '.br{height:100%;}.ssr-plugin'
import '.b1{border:none;}.ssr-plugin'
import '.b2{background-color:transparent;}.ssr-plugin'
import '.f0{border-radius:0px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.cu{position:sticky;}.ssr-plugin'
import '.f1{top:4rem;}.ssr-plugin'
import '.f2{z-index:7;}.ssr-plugin'
import '.ae{background-color:var(--shades-white);}.ssr-plugin'
import '.f3{padding-bottom:1rem;}.ssr-plugin'
import '.s{margin-bottom:1rem;}.ssr-plugin'
import '.f4{border-bottom:var(--blue-border);}.ssr-plugin'
import '.a6{position:fixed;}.ssr-plugin'
import '.cv{top:0px;}.ssr-plugin'
import '.bp{left:0px;}.ssr-plugin'
import '.bq{right:0px;}.ssr-plugin'
import '.f5{bottom:0px;}.ssr-plugin'
import '.ee{z-index:9999;}.ssr-plugin'
import '.f6{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.dc{justify-content:flex-end;}.ssr-plugin'
import '.c7{flex:1;}.ssr-plugin'
import '.ar{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="bi bk t br b1 b2 f0"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="a b ab"
    >
      <div className="cu f1 f2 ae f3 s f4 a"
      >
        <Button
          variant="link"
          label={collapsedButtonLabel}
          onClick={() => setIsOpen(true)}
        />
      </div>

      <div className="a6 cv bp bq f5 ee ae f6 a b"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="bk a dc f4"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="c7 ar">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
